// Copyright ©️ 2026 eVolve MEP, LLC

import { useEvolvePost, type WorkOrderPaginated } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = {
  opened: boolean;
  onClose: () => void;
  workOrder: WorkOrderPaginated;
};

export const ReassignMachineProfiles = ({ opened, onClose, workOrder }: Props) => {
  const { apiCall: reassignMachineProfilesApiCall } = useEvolvePost(
    `shop/workOrder/${workOrder.workOrderId}/reassignBenderProfiles`,
  );

  return (
    <WrappedModal
      title="Reassign machine profiles"
      opened={opened}
      onClose={onClose}
      confirmationText="Reassign"
      onConfirm={async () => {
        await reassignMachineProfilesApiCall({}).then(() => {
          notifications.show({
            title: 'Successfully reassigned',
            message: (
              <>
                All fabrication parts in <b>{workOrder.name}</b> have been reassigned to the default machine profiles.
              </>
            ),
            color: 'green',
          });
        });
      }}
    >
      <Text>
        Performing this action will reassign the machine profiles on every fabrication part in this work order based on
        the defaults set for <b>{workOrder.facilityName}</b>.
      </Text>
    </WrappedModal>
  );
};
